import axios from "./axios";
import { ADMIN_API_ROOT } from "./api-root";

export const CardServer = {
    Card: {
        /**
         * 获取卡片列表
        */
        list: (params: any) => {
            return axios.get(
                `${ADMIN_API_ROOT}/card/list`,
                { params }
            );
        },
        detail: (params: any) => {
            return axios.get(
                `${ADMIN_API_ROOT}/card/card-sensitive-details`,
                { params }
            );
        },
        /**
         * 卡片状态更新
         */
        update: async (params: any) => {
            return axios.post(
                `${ADMIN_API_ROOT}/card/card-update-status`,
                params
            );
        },
        /**
         * 刷新卡余额
         */
        refresh: (params?: any) => {
            return axios.get(
                `${ADMIN_API_ROOT}/card/refresh-balance`,
                { params }
            );
        },
        /**
         * 卡片类型更新
         */
        modifyCardType: async (params: any) => {
            return axios.post(
                `${ADMIN_API_ROOT}/card/card-update`,
                params
            );
        },
        // 卡片列表导出
        export: async (params: any) => {
            return axios.get(
                `${ADMIN_API_ROOT}/card/export`,
                {
                    params,
                    headers: { "content-type": "application/json; charset=utf-8", },
                    responseType: "blob",
                    'Accept': 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
                },
            );
        },
    },
    Product: {
        /**
         * 获取卡产品列表
        */
        list: (params: any) => {
            return axios.get(
                `${ADMIN_API_ROOT}/card-product/list`,
                { params }
            );
        },
        /**
        * 修改状态
        */
        enabled: async (params: any) => {
            return axios.post(
                `${ADMIN_API_ROOT}/card-product/update-status`,
                { ...params, Status: params.Status ? 1 : 2 }
            );
        },
        /**
         * 卡产品状态更新
         */
        refresh: (params?: any) => {
            return axios.get(
                `${ADMIN_API_ROOT}/card-product/refresh`,
                { params }
            );
        },
        /**
         * 卡产品更新
        */
        update: (params: any) => {
            return axios.post(
                `${ADMIN_API_ROOT}/card-product/update`,
                params
            );
        }
    },
    Record: {
        /**
         * 卡片充值提现记录列表
        */
        list: (params: any) => {
            return axios.get(
                `${ADMIN_API_ROOT}/card/card-balance-log-list`,
                { params }
            );
        },
        /**
         * 卡片状态列表
        */
        cardStatus: (params: any) => {
            return axios.get(
                `${ADMIN_API_ROOT}/card/udpay-card-status-list`,
                { params }
            );
        },
    },
    Transaction: {
        /**
         * 卡账单（交易记录）
        */
        list: (params: any) => {
            return axios.get(
                `${ADMIN_API_ROOT}/card/card-transactions`,
                { params }
            );
        },
    },
    Holder: {
        /**
         * 持卡人列表
        */
        list: (params: any) => {
            return axios.get(
                `${ADMIN_API_ROOT}/card/cardholder-list`,
                { params }
            );
        },
        // 编辑持卡人
        update: (params: any) => {
            return axios.post(
                `${ADMIN_API_ROOT}/card/cardholder-update`,
                params
            );
        },
    },
    Apply: {
        /**
         * 实体卡申请列表
        */
        list: (params: any) => {
            return axios.get(
                `${ADMIN_API_ROOT}/physical-card/apply-list`,
                { params }
            );
        },
        /**
         * 实体卡申请审核
        */
        audit: (params: any) => {
            return axios.post(
                `${ADMIN_API_ROOT}/physical-card/audit`,
                params
            );
        },
        /**
         * 实体卡申请列表信息更新(快递信息、审核信息）
        */
        update: (params: any) => {
            return axios.post(
                `${ADMIN_API_ROOT}/physical-card/update`,
                params
            );
        }
    },
    ImportCard: {
        /**
         * 获取导入的卡片列表
        */
        list: (params: any) => {
            return axios.get(
                `${ADMIN_API_ROOT}/card-data/list`,
                params,
            );
        },
        addCard: async (params: any) => {
            return axios.post(
                `${ADMIN_API_ROOT}/card-data/add`,
                params,
            );
        },
        import: async (params: any) => {
            return axios.post(
                `${ADMIN_API_ROOT}/card-data/file-add`,
                params,
            );
        },
        update: async (params: any) => {
            return axios.post(
                `${ADMIN_API_ROOT}/card-data/update`,
                params,
            );
        },
    },
    Transfer: {
        /**
         * 卡片充值提现记录列表
        */
        list: (params: any) => {
            return axios.get(
                `${ADMIN_API_ROOT}/card/transfer-list`,
                { params }
            );
        },
    },
    VirtualVip: {
        /**
         * 虚拟vip列表
        */
        list: (params: any) => {
            return axios.get(
                `${ADMIN_API_ROOT}/virtual-vip-card/list`,
                { params }
            );
        },
    },    
    VipCardTask: {
        /**
         * vip卡任务列表
        */
        list: (params: any) => {
            return axios.get(
                `${ADMIN_API_ROOT}/virtual-vip-card/task-list`,
                { params }
            );
        },
        create: (params: any) => {
            return axios.post(
                `${ADMIN_API_ROOT}/virtual-vip-card/create-task`,
                params,
            )
        },
        cardProductList: (params: any) => {
            return axios.get(
                `${ADMIN_API_ROOT}/virtual-vip-card/card-product-select-list`,
                { params }
            );
        },
    },
}